import _import from './_import.js';

export default [
    {
        path: '/pay/inputInfo',
        name: 'pay',
        component: _import('payment/inputInfo')
    },
    {
        path: '/pay/paySettle',
        name: 'paySettle',
        component: _import('payment/paySettle')
    },
    {
        path: '/pay/wxpay',
        name: 'wxpay',
        component: _import('payment/oldwxpay')
    },
    {
        path: '/pay/nwxpay',
        name: 'nwxpay',
        component: _import('payment/wxpay')
    },
    {
        path: '/pay/Stripe',
        name: 'Stripe',
        component: _import('payment/Stripe')
    },  
    {
        path: '/pay/paypal',
        name: 'paypal',
        component: _import('payment/paypal')
    },
    {
        path: '/pay/authPaypal',
        name: 'authPaypal',
        component: _import('payment/authPaypal')
    },
    {
        path: '/pay/userPaypal',
        name: 'userPay',
        component: _import('payment/authPaypal')
    },
    {
        path: '/pay/braintree',
        name: 'braintree',
        component: _import('payment/braintree')
    },
];


// WEBPACK FOOTER //
// ./src/router/pay.js